import { useEffect, useState } from "react";
import "@/App.css";
import { initLenis } from "@/lib/scroll";
import { CheckoutProvider } from "@/components/landing/ui";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Modules from "@/components/landing/Modules";
import Pains from "@/components/landing/Pains";
import Method from "@/components/landing/Method";
import DeepDive from "@/components/landing/DeepDive";
import NotACourse from "@/components/landing/NotACourse";
import Social from "@/components/landing/Social";
import Pricing from "@/components/landing/Pricing";
import GuaranteeFaq from "@/components/landing/GuaranteeFaq";
import Final from "@/components/landing/Final";
import { StickyCta, CheckoutModal } from "@/components/landing/StickyCta";
import MomPreview from "@/components/mom/Preview";

export default function App() {
  const [checkoutOpen, setCheckoutOpen] = useState(false);

  useEffect(() => initLenis(), []);

  if (window.location.pathname.startsWith("/preview-mom")) {
    return <MomPreview />;
  }

  return (
    <CheckoutProvider value={() => setCheckoutOpen(true)}>
      <div className="overflow-x-clip bg-hc-bg font-sans text-hc-paper antialiased">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Modules />
          <Pains />
          <Method />
          <DeepDive />
          <NotACourse />
          <Social />
          <Pricing />
          <GuaranteeFaq />
          <Final />
        </main>
        <StickyCta />
        <CheckoutModal open={checkoutOpen} onClose={() => setCheckoutOpen(false)} />
      </div>
    </CheckoutProvider>
  );
}
